import { render, staticRenderFns } from "./FlexContainer.vue?vue&type=template&id=c12a1d20&scoped=true"
import script from "./FlexContainer.vue?vue&type=script&lang=js"
export * from "./FlexContainer.vue?vue&type=script&lang=js"
import style0 from "./FlexContainer.vue?vue&type=style&index=0&id=c12a1d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12a1d20",
  null
  
)

export default component.exports